"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoFieldTelephone = PersonalInfoFieldTelephone;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const account_1 = require("@src/types/account");
function PersonalInfoFieldTelephone() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: account_1.EPersonalInfoField.telephone, label: intl.formatMessage({ id: 'admin.personal_info_edit.telephone' }), rules: [
            {
                required: true,
                message: intl.formatMessage({
                    id: 'admin.personal_info_edit_validation.please_fill_phone_number',
                }),
            },
            {
                pattern: /^[^A-Za-z_~`!@#$%^&*(),.;<>?]+$/g,
                message: intl.formatMessage({
                    id: 'registration.sync_validation.restricted_symbols_telephone',
                }),
            },
            {
                max: 14,
                message: intl.formatMessage({
                    id: 'admin.personal_info_edit_validation.phone_number_too_long',
                }),
            },
            {
                min: 9,
                message: intl.formatMessage({
                    id: 'admin.personal_info_edit_validation.phone_number_too_short',
                }),
            },
        ], children: (0, jsx_runtime_1.jsx)(elements_1.Input, {}) }));
}
